"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'terra2',
  assets: [{
    description: 'The native staking token of Terra.',
    denom_units: [{
      denom: 'uluna',
      exponent: 0
    }, {
      denom: 'luna',
      exponent: 6
    }],
    base: 'uluna',
    name: 'Luna',
    display: 'luna',
    symbol: 'LUNA',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg'
    },
    coingecko_id: 'terra-luna-2',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/luna.svg'
    }]
  }, {
    description: 'Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.',
    denom_units: [{
      denom: 'cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26',
      exponent: 0
    }, {
      denom: 'astro',
      exponent: 6
    }],
    type_asset: 'cw20',
    address: 'terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26',
    base: 'cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26',
    name: 'Astroport',
    display: 'astro',
    symbol: 'ASTRO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/astro.png'
    },
    coingecko_id: 'astroport-fi',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra/images/astro.png'
    }]
  }, {
    description: 'Dinheiros is the reserve currency of dioalma.protocol, an undivisible and rare token.',
    denom_units: [{
      denom: 'cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k',
      exponent: 0
    }, {
      denom: 'Dinheiros',
      exponent: 0
    }],
    type_asset: 'cw20',
    address: 'terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k',
    base: 'cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k',
    name: 'dinheiro',
    display: 'Dinheiros',
    symbol: 'DINHEIROS',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Dinheiros.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Dinheiros.png'
    }]
  }, {
    description: 'Reis is the king of trading, high volume high liquidity, sibling of Dinheiros, Reis and Alem, a token of dioalma.protocol.',
    denom_units: [{
      denom: 'cw20:terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8',
      exponent: 0
    }, {
      denom: 'Reis',
      exponent: 6
    }],
    type_asset: 'cw20',
    address: 'terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8',
    base: 'cw20:terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8',
    name: 'real',
    display: 'Reis',
    symbol: 'REIS',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Reis.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Reis.png'
    }]
  }, {
    description: 'Escudos is the everyday currency of dioalma.protocol, good to send money back and foward.',
    denom_units: [{
      denom: 'cw20:terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg',
      exponent: 0
    }, {
      denom: 'Escudos',
      exponent: 6
    }],
    type_asset: 'cw20',
    address: 'terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg',
    base: 'cw20:terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg',
    name: 'escudo',
    display: 'Escudos',
    symbol: 'ESCUDOS',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Escudos.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Escudos.png'
    }]
  }, {
    description: 'Alem is a local currency for the region of Alentejo in Portugal, sibling of Dinheiros, Reis and Alem, a token of dioalma.protocol.',
    denom_units: [{
      denom: 'cw20:terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q',
      exponent: 0
    }, {
      denom: 'Alem',
      exponent: 6
    }],
    type_asset: 'cw20',
    address: 'terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q',
    base: 'cw20:terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q',
    name: 'alentejo.money',
    display: 'Alem',
    symbol: 'ALEM',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Alem.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/Alem.png'
    }]
  }, {
    description: 'ERIS liquid staked LUNA.',
    type_asset: 'cw20',
    address: 'terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct',
    denom_units: [{
      denom: 'cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct',
      exponent: 0
    }, {
      denom: 'ampluna',
      exponent: 6
    }],
    base: 'cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct',
    name: 'ERIS Amplified LUNA',
    display: 'ampluna',
    symbol: 'ampLUNA',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampluna.svg'
    },
    coingecko_id: 'eris-amplified-luna',
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampluna.svg'
    }]
  }, {
    description: 'Lion DAO is a community DAO that lives on the Terra blockchain with the mission to reactivate the LUNAtic community and showcase Terra protocols & tooling',
    type_asset: 'cw20',
    address: 'terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv',
    denom_units: [{
      denom: 'cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv',
      exponent: 0
    }, {
      denom: 'roar',
      exponent: 6
    }],
    base: 'cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv',
    name: 'Lion DAO',
    display: 'roar',
    symbol: 'ROAR',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png'
    },
    coingecko_id: 'lion-dao',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/roar.png'
    }]
  }, {
    description: 'GEM DAO, building a decentralized, community-owned, low-supply store of value',
    type_asset: 'cw20',
    address: 'terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv',
    denom_units: [{
      denom: 'cw20:terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv',
      exponent: 0
    }, {
      denom: 'gem',
      exponent: 6
    }],
    base: 'cw20:terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv',
    name: 'GEM DAO',
    display: 'gem',
    symbol: 'GEM',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gem.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/gem.png'
    }]
  }, {
    description: 'Lion Cub DAO is a useless meme community DAO on Terra',
    type_asset: 'cw20',
    address: 'terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t',
    denom_units: [{
      denom: 'cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t',
      exponent: 0
    }, {
      denom: 'cub',
      exponent: 6
    }],
    base: 'cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t',
    name: 'Lion Cub DAO',
    display: 'cub',
    symbol: 'CUB',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/cub.png'
    }]
  }, {
    description: 'BLUE CUB DAO is a community DAO on Terra',
    type_asset: 'cw20',
    address: 'terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584',
    denom_units: [{
      denom: 'cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584',
      exponent: 0
    }, {
      denom: 'blue',
      exponent: 6
    }],
    base: 'cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584',
    name: 'BLUE CUB DAO',
    display: 'blue',
    symbol: 'BLUE',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/blue.png'
    }]
  }, {
    description: 'Liquidity token, NFT, HARVEST FOR VALUE',
    type_asset: 'cw20',
    address: 'terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn',
    denom_units: [{
      denom: 'cw20:terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn',
      exponent: 0
    }, {
      denom: 'xxx',
      exponent: 10
    }],
    base: 'cw20:terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn',
    name: 'TheOnlyOne',
    display: 'xxx',
    symbol: 'xxx',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xxx3.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xxx3.png'
    }]
  }, {
    description: 'The GraveDigger is the Liquid Staking Product of BackBone Labs. It will have its own platform. Its liquid staking derivative (LSD) is boneLUNA.',
    type_asset: 'cw20',
    address: 'terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml',
    denom_units: [{
      denom: 'cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml',
      exponent: 0
    }, {
      denom: 'bluna',
      exponent: 6
    }],
    base: 'cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml',
    name: 'boneLuna',
    display: 'bluna',
    symbol: 'bLUNA',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/boneluna.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/boneluna.png'
    }]
  }, {
    description: 'Sayve is a revolutionary language learning app in the Web3 era that combines gamification, blockchain technology, and a Metaverse experience to motivate users to learn languages while earning rewards.',
    type_asset: 'cw20',
    address: 'terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3',
    denom_units: [{
      denom: 'cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3',
      exponent: 0
    }, {
      denom: 'sayve',
      exponent: 6
    }],
    base: 'cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3',
    name: 'sayve',
    display: 'sayve',
    symbol: 'SAYVE',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/sayve.svg'
    }]
  }, {
    description: 'ERIS Alliance Staked ampWHALE on Terra',
    denom_units: [{
      denom: 'factory/terra1j35ta0llaxcf55auv2cjqau5a7aee6g8fz7md7my7005cvh23jfsaw83dy/ampWHALEt',
      exponent: 0
    }, {
      denom: 'ampWHALEt',
      exponent: 6
    }],
    base: 'factory/terra1j35ta0llaxcf55auv2cjqau5a7aee6g8fz7md7my7005cvh23jfsaw83dy/ampWHALEt',
    name: 'ERIS Alliance Staked ampWHALE',
    display: 'ampWHALEt',
    symbol: 'ampWHALEt',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampwhalet.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ampwhalet.svg'
    }]
  }, {
    description: 'ERIS Alliance Staked boneWHALE on Terra',
    denom_units: [{
      denom: 'factory/terra10j3zrymfrkta2pxe0gklc79gu06tqyuy8c3kh6tqdsrrprsjqkrqzfl4df/boneWHALEt',
      exponent: 0
    }, {
      denom: 'boneWHALEt',
      exponent: 6
    }],
    base: 'factory/terra10j3zrymfrkta2pxe0gklc79gu06tqyuy8c3kh6tqdsrrprsjqkrqzfl4df/boneWHALEt',
    name: 'ERIS Alliance Staked boneWHALE',
    display: 'boneWHALEt',
    symbol: 'boneWHALEt',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bonewhalet.svg'
    },
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/bonewhalet.svg'
    }]
  }, {
    description: 'ERIS Liquid Enterprise Staked ROAR',
    denom_units: [{
      denom: 'factory/terra1vklefn7n6cchn0u962w3gaszr4vf52wjvd4y95t2sydwpmpdtszsqvk9wy/ampROAR',
      exponent: 0
    }, {
      denom: 'ampROAR',
      exponent: 6
    }],
    base: 'factory/terra1vklefn7n6cchn0u962w3gaszr4vf52wjvd4y95t2sydwpmpdtszsqvk9wy/ampROAR',
    name: 'ERIS Amplified ROAR',
    display: 'ampROAR',
    symbol: 'ampROAR',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/amproar.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/amproar.png'
    }]
  }, {
    description: 'Nico Dao Money',
    type_asset: 'cw20',
    address: 'terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3',
    denom_units: [{
      denom: 'cw20:terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3',
      exponent: 0
    }, {
      denom: 'nico',
      exponent: 18
    }],
    base: 'cw20:terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3',
    name: 'nico',
    display: 'nico',
    symbol: 'NICO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/nicodao.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/nicodao.png'
    }]
  }, {
    description: 'Sailing the Seas DAO is a community DAO built on Enterprise on Terra',
    type_asset: 'cw20',
    address: 'terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala',
    denom_units: [{
      denom: 'cw20:terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala',
      exponent: 0
    }, {
      denom: 'seas',
      exponent: 6
    }],
    base: 'cw20:terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala',
    name: 'Sailing The SeaS DAO',
    display: 'seas',
    symbol: 'SEAS',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/SEAS.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/SEAS.png'
    }]
  }, {
    description: 'A community DAO built on Enterprise',
    type_asset: 'cw20',
    address: 'terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v',
    denom_units: [{
      denom: 'cw20:terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v',
      exponent: 0
    }, {
      denom: 'bitz',
      exponent: 6
    }],
    base: 'cw20:terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v',
    name: 'BitzDAO',
    display: 'bitz',
    symbol: 'BITZ',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/BITZ.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/BITZ.png'
    }]
  }, {
    denom_units: [{
      denom: 'ibc/A356EC90DC3AE43D485514DA7260EDC7ABB5CFAA0654CE2524C739392975AD3C',
      exponent: 0,
      aliases: ['wstETH']
    }, {
      denom: 'factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH',
      exponent: 18
    }],
    type_asset: 'ics20',
    base: 'ibc/A356EC90DC3AE43D485514DA7260EDC7ABB5CFAA0654CE2524C739392975AD3C',
    name: 'Wrapped Lido Staked Ether',
    display: 'wstETH',
    symbol: 'wstETH',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'neutron',
        base_denom: 'factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH',
        channel_id: 'channel-25'
      },
      chain: {
        channel_id: 'channel-229',
        path: 'transfer/channel-229/factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'neutron',
        base_denom: 'factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH'
      },
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg'
    }],
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/wsteth.svg'
    }
  }, {
    description: 'SEUL DAO',
    type_asset: 'cw20',
    address: 'terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l',
    denom_units: [{
      denom: 'cw20:terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l',
      exponent: 0
    }, {
      denom: 'seul',
      exponent: 6
    }],
    base: 'cw20:terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l',
    name: 'seul',
    display: 'seul',
    symbol: 'SEUL',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/seul.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/seul.png'
    }]
  }, {
    description: 'SEUL DAO',
    type_asset: 'cw20',
    address: 'terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5',
    denom_units: [{
      denom: 'cw20:terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5',
      exponent: 0
    }, {
      denom: 'xseul',
      exponent: 6
    }],
    base: 'cw20:terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5',
    name: 'xseul',
    display: 'xseul',
    symbol: 'xSEUL',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xseul.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/xseul.png'
    }]
  }, {
    description: 'ITO DAO',
    type_asset: 'cw20',
    address: 'terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s',
    denom_units: [{
      denom: 'cw20:terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s',
      exponent: 0
    }, {
      denom: 'ito',
      exponent: 6
    }],
    base: 'cw20:terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s',
    name: 'ito',
    display: 'ito',
    symbol: 'ITO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/I.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/I.png'
    }]
  }, {
    description: 'Chris Armani Token',
    type_asset: 'cw20',
    address: 'terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8',
    denom_units: [{
      denom: 'cw20:terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8',
      exponent: 0
    }, {
      denom: 'ARMANI',
      exponent: 6
    }],
    base: 'cw20:terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8',
    name: 'ARMANI',
    display: 'ARMANI',
    symbol: 'ARMANI',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/armani.png'
    },
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/armani.png'
    }]
  }, {
    description: 'useless meme coin',
    type_asset: 'cw20',
    address: 'terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun',
    denom_units: [{
      denom: 'cw20:terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun',
      exponent: 0
    }, {
      denom: 'DROGO',
      exponent: 6
    }],
    base: 'cw20:terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun',
    name: 'DROGO',
    display: 'DROGO',
    symbol: 'DROGO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/drogo.png'
    }
  }, {
    description: 'ado the flower of night',
    type_asset: 'cw20',
    address: 'terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu',
    denom_units: [{
      denom: 'cw20:terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu',
      exponent: 0
    }, {
      denom: 'ADO',
      exponent: 6
    }],
    base: 'cw20:terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu',
    name: 'ADO',
    display: 'ADO',
    symbol: 'ADO',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/terra2/images/ADO.png'
    }
  }]
};
var _default = exports["default"] = info;